import React, {Component} from 'react';
import propTypes from 'prop-types';
import {Flyover, FlyoverFooter} from '@sinclair-digital/sbg-storyline-components/src/components/Flyover';
import {default as Search} from '@sinclair-digital/sbg-storyline-components/src/components/Search';
import {default as TextInput} from '@sinclair-digital/sbg-storyline-components/src/components/forms/TextInput';
import {default as Select} from '@sinclair-digital/sbg-storyline-components/src/components/forms/Select';
import {default as Option} from '@sinclair-digital/sbg-storyline-components/src/components/forms/Option';
import {default as Button} from '@sinclair-digital/sbg-storyline-components/src/components/Button';

import classes from './BulkEditTagPanel.scss';
import uuidV4 from 'uuid/v4';

const UNSET_TAG_TYPE = 'Tag Type';
const TAG_TYPES = [
    'City',
    'Company',
    'Country',
    'Entertainment',
    'Entitlement',
    'Event',
    'HashTag',
    'Organization',
    'Person',
    'Place',
    'Product',
    'Region',
    'Social',
    'Source',
    'Technology',
    'Topic',
];

class BulkEditTagPanel extends Component {

    constructor(props){
        super(props);

        this.state = {
            tagSearchQuery: '',
            tagInputValue: '',
            tagTypeValue: '',
            selectedTags: [],
        };

        this.tagSelectList = React.createRef();
    }

    static propTypes = {
        tagList: propTypes.arrayOf(propTypes.object),
        onTagSearch: propTypes.func,
        onAddTag: propTypes.func,
        onApplyTags: propTypes.func,
        toggleVisibility: propTypes.func,
        visible: propTypes.boolean,
    }

    setTagSearchQuery = query => this.setState({tagSearchQuery: query});

    setTagTypeValue = event => {
        this.setState({tagTypeValue: event.target.value});
    }

    setTagInputValue = event => {
        this.setState({tagInputValue: event.target.value});
    }

    applyTags = () => {
        if (this.state.selectedTags.length){
            this.props.onApplyTags(this.state.selectedTags);
            this.props.toggleVisibility();
        }
    }

    addTagToList = () => {
        const {
            tagInputValue: name,
            tagTypeValue: dimension,
        } = this.state;

        if (name && dimension && dimension !== UNSET_TAG_TYPE){
            const tag = {
                name,
                dimension,
                weight: 1,
                uuid: uuidV4(),
                userGenerated: true,
                removeable: true,
            };

            this.props.onAddTag(tag);
        }
    }

    handleTagSearch = () => this.props.onTagSearch(this.state.tagSearchQuery);

    handleTagSelection = () => {
        const selectedTags = [...this.tagSelectList.current.selectedOptions].map(
            o => this.props.tagList[+o.value]
        );
        this.setState({selectedTags});
    }

    render() {
        const {
            state: {
                tagSearchQuery,
            },
            props: {
                visible,
                toggleVisibility,
                tagList,
            },
            handleTagSearch,
        } = this;

        return <Flyover size={'content'} isOn={visible} theme={'teaser'} className={classes.tagControlPanel}>
            <div className={classes.formBody}>
                <div className={classes.formInner}>
                    <div className={classes.searchWrapper}>
                        <Search
                            placeholder={'Search for Tags'}
                            value={tagSearchQuery}
                            onChange={this.setTagSearchQuery}
                        />
                        <Button
                            className={classes.tagSearchButton}
                            onClick={handleTagSearch}
                        >
                            Search
                        </Button>
                    </div>
                    <div className={classes.addTagWrapper}>
                        <TextInput
                            placeholder={'Add a new tag'}
                            onChange={this.setTagInputValue}
                            theme={'default'}
                        />
                        <Select
                            onChange={this.setTagTypeValue}
                        >
                            <Option
                                key={UNSET_TAG_TYPE}
                                value={UNSET_TAG_TYPE}
                                label={UNSET_TAG_TYPE}
                            />
                            {TAG_TYPES.map(t => (
                                <Option
                                    key={t}
                                    value={t}
                                    label={t}
                                />
                            ))}
                        </Select>
                        <Button
                            displayType={'primary'}
                            onClick={this.addTagToList}
                        >
                            Add Tag to List
                        </Button>
                    </div>
                    <h3 className={classes.resultsHeader}>Results: </h3>
                    <select
                        multiple
                        className={classes.tagList}
                        ref={this.tagSelectList}
                        onChange={this.handleTagSelection}
                    >
                        {tagList.map((t, i) => (
                            <option
                                key={`${t.name}:${t.dimension}`}
                                value={i}
                            >
                                {`${t.name} : ${t.dimension}`}
                            </option>
                        ))}
                    </select>
                </div>
                <FlyoverFooter>
                    <Button
                        className={classes.backButton}
                        onClick={toggleVisibility}
                    >
                        Back
                    </Button>
                    <Button
                        displayType={'primary'}
                        onClick={this.applyTags}
                    >
                        Apply to Selected
                    </Button>
                </FlyoverFooter>
            </div>
        </Flyover>;
    }
}

export default BulkEditTagPanel;
